export const REVIEW_LIST_PAGE_LIMIT = 20;
export const NEWS_LIST_PAGE_LIMIT = 5;
export const CATEGORY_LIST_PAGE_LIMIT = 50;
